import React, { useContext, useEffect, useState, useRef } from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { emitOtkCompanyCertStateMutation, OTK_COMPANY_CERT_KIND } from '../../../utils/otkCompanyCertStateListSync';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { LocaleContext } from '../../../components/LocaleContext';
import { MultiSelect } from 'primereact/multiselect';

export default function OtkCompanyCertRecordAdd({ certificate: propCertificate, lastRecord: propLastRecord }){
    
    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const {setDialogText,setVisible,toast,openFavoriteDialog,setFastView} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const fileListRef = useRef(null);

    const [company,setCompany] = useState("");
    const [certificates,setCertificates] = useState([]);

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("edit otk-company"))?false:true);

    const [fileList, setFileList] = useState([]);
    const [otkCertificates, setOtkCertificates] = useState([]);
    useEffect(() => {
        getRequest('/api/company_certificates/paged?type=otk&size=500&page=1')
            .then((r) => setOtkCertificates(r?.data ?? []))
            .catch(() => setOtkCertificates([]));
    }, []);
    useEffect(() => {
        if (!propCertificate) return;
        let companyId = propCertificate.company_id ?? propCertificate.company?.id;
        if (companyId == null && propCertificate.certificate_id != null) {
            const cert = otkCertificates?.find(c => c.id == propCertificate.certificate_id);
            companyId = cert?.company_id;
        }
        if (companyId != null) {
            setCompany(String(companyId));
            let certs = otkCertificates?.filter(c => c.company_id == companyId)
                ?? state.otk_companies?.find(c => c.id === parseInt(companyId))?.certificates
                ?? [];
            if (propCertificate?.id && !certs.some(c => c.id == propCertificate.id)) {
                certs = [...certs, propCertificate];
            }
            setCertificates(certs);
        }
    }, [propCertificate?.id, propCertificate?.company_id, propCertificate?.certificate_id, otkCertificates, state.otk_companies]);

    const getSelectedCert = (certId) => {
        if (propCertificate && certId == propCertificate.id) return propCertificate;
        return certificates?.find(c => c.id == certId) ?? null;
    };

    function addNewTraining(){
        dispatch({type:'create_new_tab',name: t('Otk.NewPartnerDocumentation'), translationKey: 'Otk.NewPartnerDocumentation', legacyLabel: t('Otk.NewPartnerDocumentation'),page:'OtkCompanyCertificateAdd',props:{certificate: null,type:'add'},mask:'qlty031'})
      }
      function copyTraining(){
        dispatch({type:'create_new_tab',name: t('Otk.NewPartnerDocumentation'), translationKey: 'Otk.NewPartnerDocumentation', legacyLabel: t('Otk.NewPartnerDocumentation'),page:'OtkCompanyCertificateAdd',props:{certificate: formik.values,type:'add'},mask:'qlty031'})
      }

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formik = useFormik({
            initialValues: {
                start_of_validity: '',
                end_of_validity: '',
                description: propLastRecord?.description ?? '',
                certificate_id: propCertificate?.id ?? '',
            },
            enableReinitialize: true,
            validate,
            onSubmit: values => {
                const selectedCert = getSelectedCert(values.certificate_id);
                const requiresAttachment = !!selectedCert?.required_attachment;
                if (requiresAttachment && (!fileList || fileList.length === 0)) {
                    toast?.current?.show({ severity: 'warn', summary: t('Otk.MissingAttachment'), life: 4000, detail: t('Otk.DocAttachmentRequiredUpload') });
                    return;
                }
                let formData = new FormData();
                for (let value in values) {
                    formData.append(value, values[value] != null ? values[value] : "");
                }
                /*for (var pair of formData.entries()) {
                    console.log(pair[0]+ ', ' + pair[1]); 
                }*/
                for(let i = 0;i<fileList.length;i++){
                    //console.log("IMAGE :"+fileList[i].name);
                    formData.append('files[]',fileList[i]);
                }
                setDialogText(t('Common.Saving'));
                setVisible(true);
                postRequest('/api/company_cert_records', formData,true)
                .then((response) => {
                    if (response?.status === 422) {
                        setVisible(false);
                        toast?.current?.show({ severity: 'warn', summary: t('Otk.MissingAttachment'), life: 4000, detail: response.message || t('Otk.DocAttachmentRequired') });
                        return;
                    }
                    setVisible(false);
                    console.log(response);
                    emitOtkCompanyCertStateMutation({
                        kind: OTK_COMPANY_CERT_KIND.RECORD_CREATED,
                        certificateId: values.certificate_id,
                    });
                    getRequest("/api/companies").then((response) => {
                        dispatch({type:'load_companies',newCompanies:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        //if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        formik.resetForm();
                        setCompany("");
                        setCertificates([]);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                    getRequest('/api/company_certificates/paged?type=otk&size=500&page=1').then((r) => setOtkCertificates(r?.data ?? []));
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('SummaryEmailOTKAdd.Error.Offline'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            },
        });

    function filterCertificates(company_id){
        setCompany(company_id);
        if(company_id=="")setCertificates([]);
        else setCertificates(state.otk_companies.filter(company => company.id === parseInt(company_id))[0]?.certificates);
    }

    const handleFileChange = (event) => {
        setFileList(event.target.files);
    };

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTraining()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyTraining()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('Otk.NewTrainingCompany'),"TrainingRecordAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("TrainingRecordAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)] bg-gray-100">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.PRIDAT_DOKUMENTACIU_PARTNERA')}</h1>
                    <div>
                        <label
                            htmlFor="company"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Obchodny_partner')}</label>
                        <select 
                        required
                        name='company'
                        onChange={(e) => filterCertificates(e.target.value)} value={company}
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Ui.R67.Vyber_obch_partnera')}</option>
                          {state.otk_companies.map((company) => (
                            <option key={company.id} value={company.id}>{company.name}</option>
                            ))}
                        </select>
                    </div>
                        <div>
                        <label
                            htmlFor="certificate_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Dokumentacia_obchodneho_partnera')}</label>
                        <select 
                        required
                        name="certificate_id"
                        onChange={formik.handleChange} value={formik.values.certificate_id} 
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('Ui.R67.Vyber_dokumentaciu')}</option>
                          {certificates.map((certificate) => (
                            <option key={certificate.id} value={certificate.id}>{certificate.name}</option>
                          ))}
                        </select>
                        {formik.values.certificate_id && (() => {
                            const sel = getSelectedCert(formik.values.certificate_id);
                            return (
                                <p className="mt-1 text-sm text-gray-600">
                                    Povinná príloha: <strong>{!!sel?.required_attachment ? t('Common.Yes') : t('Common.No')}</strong>
                                </p>
                            );
                        })()}
                        </div>
                        <div>
                        <label
                            htmlFor="start_of_validity"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_platnosti_od')}</label>
                        <input
                            name='start_of_validity'
                            type="date" required
                            onChange={formik.handleChange} value={formik.values.start_of_validity}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="end_of_validity"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_platnosti_do')}</label>
                        <input
                            name='end_of_validity'
                            type="date" required
                            onChange={formik.handleChange} value={formik.values.end_of_validity}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Note')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div> 
                        <div>
                        <label
                            htmlFor="files"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Protokol
                            {!!getSelectedCert(formik.values.certificate_id)?.required_attachment && (
                                <span className="ml-1 text-amber-600" title={t('Otk.DocAttachmentRequiredNoDot')}>*</span>
                            )}
                        </label>
                          <input
                          accept='image/*,application/pdf'
                          name='files'
                          ref={fileListRef}
                          onChange={handleFileChange}
                          className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                          type='file'
                          multiple="multiple"
                          id='file'/>
                        </div>
                        <button type='submit' ref={submitRef}></button>
            </div>
            </div>
            </div> 
             </form>
            </div>
            </> 
            );

}